import { render, staticRenderFns } from "./size-expand.vue?vue&type=template&id=65fb9361&scoped=true&"
import script from "./size-expand.vue?vue&type=script&lang=js&"
export * from "./size-expand.vue?vue&type=script&lang=js&"
import style1 from "./size-expand.vue?vue&type=style&index=1&id=65fb9361&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fb9361",
  null
  
)

export default component.exports